import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import "./WelocateTypeFilter.css";

const TYPES = ["House", "Apartment", "Room", "Garage"];

const WelocateTypeFilter = ({ selected, onToggle }) => (
  <div className="wl-type-filter">
    <div className="wl-type-filter__options">
      {TYPES.map((type) => {
        const isSelected = selected.includes(type);
        return (
          <button
            key={type}
            className={`wl-type-filter__option${isSelected ? " wl-type-filter__option--selected" : ""}`}
            onClick={() => onToggle(type)}
          >
            <span className="wl-type-filter__option-label">{type}</span>
            {isSelected && <CheckIcon className="wl-type-filter__check" />}
          </button>
        );
      })}
    </div>
  </div>
);

export default WelocateTypeFilter;
